__turbopack_context__.v({
  "chatItem": "ChatItem-module__fRuE9G__chatItem",
  "chatItemActive": "ChatItem-module__fRuE9G__chatItemActive",
  "chatItem__date": "ChatItem-module__fRuE9G__chatItem__date",
  "chatItem__line": "ChatItem-module__fRuE9G__chatItem__line",
});
